// Modified functions to accept product_id as parameter
function addGiftWrapProductToCart(productId) {
  const formData = {
    items: [{
      id: productId,
      quantity: 1,
    }]
  };


  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      console.log('Product added:', data);
      refreshCart();
    })
    .catch((error) => {
      console.error('Error:', error);
      // Show error message to user
    })
    .finally(() => {
      // Remove loading state
      // document.body.classList.remove('cart-loading');
    });
}

function removeGiftWrapProductFromCart(productId) {
  const updates = {
    [productId]: 0
  };

  // Add loading state if needed
  // document.body.classList.add('cart-loading');

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      console.log('Product removed:', data);
      refreshCart();
    })
    .catch((error) => {
      console.error('Error:', error);
      // Show error message to user
    })
    .finally(() => {
      // Remove loading state
      // document.body.classList.remove('cart-loading');
    });
}

// Combined initialization function
function initializeGiftWrap() {
  const giftWrapBox = document.querySelector('.gift-wrapper-note');
  const mainCartWrap = document.querySelector('.main-cart-gift-wrapper');

  // Handle cart drawer gift wrap
  if (giftWrapBox) {
    const productId = giftWrapBox.getAttribute('data-product-id');
    const addProduct = giftWrapBox.querySelector('.final-add-on');

    if (productId && addProduct) {
      bindGiftWrapCheckbox(addProduct, productId);
    }
  }

  // Handle main cart gift wrap
  if (mainCartWrap) {
    const mainProductId = mainCartWrap.getAttribute('data-product-id');
    const mainAddProduct = mainCartWrap.querySelector('.drawer_add-on');

    if (mainProductId && mainAddProduct) {
      bindGiftWrapCheckbox(mainAddProduct, mainProductId);
    }
  }
}


function refreshCart() {
  // First refresh the drawer
  fetch('/?section_id=cart-drawer')
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart drawer
      const newItems = doc.querySelector('#cart-drawer__items');
      const currentItems = document.querySelector('#cart-drawer__items');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }

      const newTotal = doc.querySelector('.cart-drawer__button-price');
      const currentTotal = document.querySelector('.cart-drawer__button-price');
      if (newTotal && currentTotal) {
        currentTotal.innerHTML = newTotal.innerHTML;
      }
      const newSubtotal = doc.querySelector('.cart-drawer__subtotal-price');
const currentSubtotal = document.querySelector('.cart-drawer__subtotal-price');

if (newSubtotal && currentSubtotal) {
  currentSubtotal.innerHTML = newSubtotal.innerHTML;
}

      // Now refresh the main cart
      return fetch('/cart?view=main-cart');
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Update main cart
      const newMainCart = doc.querySelector('.order-summary__body');
      const currentMainCart = document.querySelector('.order-summary__body');
      
      if (newMainCart && currentMainCart) {
        currentMainCart.innerHTML = newMainCart.innerHTML;
      }

      const newMainTotal = doc.querySelector('.cart-recap');
      const currentMainTotal = document.querySelector('.cart-recap');
      if (newMainTotal && currentMainTotal) {
        currentMainTotal.innerHTML = newMainTotal.innerHTML;
      }

      // 🔄 Re-initialize gift wrap logic after DOM replacement
      initializeGiftWrap();
      checkCartForGiftWrap();
    })
    .catch(error => {
      console.error('Error refreshing cart:', error);
    });
}

// Store checkbox state in localStorage when changed
function bindGiftWrapCheckbox(add_product, product_id) {
  if (!add_product || !product_id) return;

  if (!add_product.hasAttribute('data-bound')) {
    add_product.addEventListener('change', function() {
      if (add_product.checked) {
        add_product.setAttribute('checked', 'checked');
        addGiftWrapProductToCart(product_id);
        localStorage.setItem('gift_wrap_checked', 'true');
        // Don't update text immediately
      } else {
        add_product.removeAttribute('checked');
        removeGiftWrapProductFromCart(product_id);
        localStorage.removeItem('gift_wrap_checked');
        // Don't update text when unchecked
      }
    });
    add_product.setAttribute('data-bound', 'true');
  }
}



// Combined cart check on load
function checkCartForGiftWrap() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(cart => {

      // Check cart drawer
      const giftWrapBox = document.querySelector('.gift-wrapper-note');

      if (giftWrapBox) {
        const productId = giftWrapBox.getAttribute('data-product-id');
        const addProduct = giftWrapBox.querySelector('.final-add-on');

        if (productId && addProduct) {
          const isGiftWrapInCart = cart.items.some(item => item.id == productId);

          addProduct.checked = isGiftWrapInCart;

          if (isGiftWrapInCart) {
            addProduct.setAttribute('checked', 'checked');
            localStorage.setItem('gift_wrap_checked', 'true');
          } else {
            addProduct.removeAttribute('checked');
            localStorage.removeItem('gift_wrap_checked');
          }

          bindGiftWrapCheckbox(addProduct, productId);
        }
      }

      // Check main cart
      const mainCartWrap = document.querySelector('.main-cart-gift-wrapper');

      if (mainCartWrap) {
        const mainProductId = mainCartWrap.getAttribute('data-product-id');
        const mainAddProduct = mainCartWrap.querySelector('.drawer_add-on');

        if (mainProductId && mainAddProduct) {
          const isGiftWrapInCart = cart.items.some(item => item.id == mainProductId);

          mainAddProduct.checked = isGiftWrapInCart;

          if (isGiftWrapInCart) {
            mainAddProduct.setAttribute('checked', 'checked');
          } else {
            mainAddProduct.removeAttribute('checked');
          }

          bindGiftWrapCheckbox(mainAddProduct, mainProductId);
        }
      }
    })
    .catch(error => {
      console.error('Error checking cart:', error);
    });
}


function observeGiftWrapCheckbox() {
  const observer = new MutationObserver(() => {
    const checkbox = document.querySelector('.gift-wrapper-note .final-add-on');
    const wrapper = document.querySelector('.gift-wrapper-note');

    if (checkbox && wrapper && !checkbox.hasAttribute('data-observed')) {
      initializeGiftWrap();
      checkCartForGiftWrap();
      checkbox.setAttribute('data-observed', 'true');
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Initialize everything
document.addEventListener('DOMContentLoaded', () => {
  initializeGiftWrap();
  checkCartForGiftWrap();
  observeGiftWrapCheckbox();
});

function formatCartDrawerDiscountBadges() {
  const badges = document.querySelectorAll('#cart-drawer .discount-badge');

  badges.forEach((badge) => {
    const text = badge.textContent.trim();

    const match = text.match(/(\d+%)\s*off\s*for\s*(£[\d,.]+\+)/i);

    if (match) {
      badge.textContent = `${match[1]} OFF · SPEND ${match[2]}`;
    }
  });
}

/* Run when the page first loads */
document.addEventListener('DOMContentLoaded', formatCartDrawerDiscountBadges);

/* Re-run whenever Shopify / Regios refreshes the cart drawer */
const discountBadgeObserver = new MutationObserver(() => {
  formatCartDrawerDiscountBadges();
});

discountBadgeObserver.observe(document.body, {
  childList: true,
  subtree: true
});
